define('responsive-game-feed/app/scripts/views/Inning',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','gameday-language/gameday-language'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var gamedayLanguage = require("gameday-language/gameday-language");
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function InningView(cfg) {
       this.element = cfg.element;
    }

    InningView.prototype = {

    
        sendPlayerMessage : function( e ) {
        	var pid = this.hash.split('=')[1];
        	var data = {
              title : "",
              pid : pid
            };

            if(Utils.options.deviceInteraction.playercard(data)){
                e.preventDefault();
                e.stopPropagation();
            }
        },
        
        render: function(cfg) {
            var that = this;
            var template = hogan.compile(cfg.template); 
            var model = cfg.model;
            
            model.data.ordinal = "th";
            model.data.inning_num = model.data.inning_num * 1;
            
            if (model.data.inning_num === 1) {
                 model.data.ordinal = "st";
            }
               
            if (model.data.inning_num === 2) {
                 model.data.ordinal = "nd";
            }
               
            if (model.data.inning_num === 3) {
                 model.data.ordinal = "rd";
            }
            
            if (model.data.top_inning === true) {
             model.data["top_inning_true"] = true;
            }
            
            if (model.data.top_inning === false) {
             model.data["top_inning_false"] = true;
            }
            
            var html = template.render({model : cfg.model, mustacheLanguage : gamedayLanguage(Utils.options.language)});
            Utils.insertItem(this.element,model,html);
            
            this.element.find("#"+ cfg.model.guid).find("a.player-link").on("click", function(e) {
                 
                 Utils.sendPlayerMessage.call(this, {target: $(this), event:e});
                 
               });
            $(cfg.feedView).trigger("renderCBTracker_"+cfg.model.guid, cfg.model.guid); 
        }
       
   };    

    return InningView;;

});
